import React from 'react'

export default function DateTimeInput({ type = 'time', value, onChange, disabled = false, ...props }) {
  return (
    <input
      type={type}
      value={value || ''}
      onChange={onChange}
      onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
      disabled={disabled}
      className="block w-full rounded-md border-gray-300 shadow-sm focus:ring-sky-500 focus:border-sky-500 sm:text-sm disabled:bg-gray-100 disabled:cursor-not-allowed"
      {...props}
    />
  )
}
